import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { isPlatformBrowser } from '@angular/common';
import { AnalyticsService } from '../../core/services/analytics.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public form: UntypedFormGroup;

  public submitAttempted = false;
  public loading = false;
  public errorMsg: string;

  public isBrowser = isPlatformBrowser(this.platformId);

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private router: Router,
    private analytics: AnalyticsService,
    @Inject(PLATFORM_ID) protected platformId,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const data = this.activatedRoute.snapshot.queryParams; // for admin access
    this.generateForm(data);
  }

  generateForm(data) {
    this.form = this.fb.group({
      'email': [data?.e || '', [Validators.required, Validators.email]],
      'password': [data.p || '', [Validators.required]],
    });
  }

  submit() {
    this.submitAttempted = true;
    this.errorMsg = null;

    if (!this.form.valid) {
      this.errorMsg = ' ';
      return false;
    }

    this.loading = true;

    const payload = {
      email: this.form.get('email').value?.trim(),
      password: this.form.get('password').value?.trim(),
    };

    this.authService.login(payload.email, payload.password).subscribe(res => {
      this.analytics.trackEvent('login', 'engagement', 'email');
      this.analytics.trackProductAnalyticsEvent('login', {medium: 'email'});
      localStorage?.removeItem('referral');

      if (isPlatformBrowser(this.platformId) && localStorage?.getItem('redirect:url')) {
        this.router.navigateByUrl(localStorage?.getItem('redirect:url'));
        localStorage?.removeItem('redirect:url');
      } else {
        this.router.navigateByUrl('/dashboard');
      }

    }, err => {
      this.errorMsg = err.errMsg;
      this.loading = false;
    });
  }

  socialError() {
    this.errorMsg = this.translateService.instant('GENERAL.error');
  }

}
